/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { LaunchParameters, LaunchTokenHeader } from './LaunchParameterService';
import {
  EndpointParameters,
  EndpointTokenHeader,
} from './EndpointParameterService';

export interface LaunchTokenInput {
  header: LaunchTokenHeader;
  parameters: LaunchParameters;
}

export interface EndpointTokenInput {
  header: EndpointTokenHeader;
  parameters: EndpointParameters;
}

export const createJwtFromParameters = (
  token: LaunchTokenInput | EndpointTokenInput
): string => {
  const encodeBase64Url = (param: string) =>
    window
      .btoa(param)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/m, '');

  const headerBase64Url = encodeBase64Url(JSON.stringify(token.header));
  const payloadBase64Url = encodeBase64Url(JSON.stringify(token.parameters));
  const SIGNATURE_BASE64URL = '';
  const JWT_PART_DELIMITER = '.';

  return (
    headerBase64Url +
    JWT_PART_DELIMITER +
    payloadBase64Url +
    JWT_PART_DELIMITER +
    SIGNATURE_BASE64URL
  );
};

export const createPredefinedTokenFromParameters = (
  meetingId?: string,
  build?: string,
  sessionTrackingId?: string
): string => {
  // randomness required for Launcher Telemetry to work
  const randomPart = `-r${Math.random()
    .toString(36)
    .substring(2)}${Math.random().toString(36).substring(2)}`;
  const buildPart = build ? `-b${build}` : '';
  const meetingIdPart = meetingId ? `-m${meetingId}` : '';
  // "-" is replaced by "_" in sessionTrackingId, since "-" is the parameter separator. Launcher Service will reverse this (see PredefinedTokenBackend.java:146).
  const sessionTrackingIdPart = sessionTrackingId
    ? `-s${sessionTrackingId.replace(/-/g, '_')}`
    : '';
  return `g2m${randomPart}${buildPart}${meetingIdPart}${sessionTrackingIdPart}`;
};
